(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hdt-featured-collection').forEach(section => {
    const link = section.querySelector('.custom_link');
    const items = section.querySelector('hdt-reval-items');
    if (!link || !items) return;
    const firstClass = items.classList[0];
    link.style.cursor = 'pointer'; // show pointer on hover
    link.addEventListener('click', function() {
      window.location.href = firstClass; // navigate to the URL
    });
  });

  } catch(e) { console.error(e); }
})();
})();
